import AdvertisersListPage from "./AdvertisersListPage";

export default AdvertisersListPage;
